import React, {
  useDeferredValue,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  Badge,
  Button,
  Dropdown,
  message,
  Select,
  Spin,
  Typography,
} from "antd";
import {
  ExportOutlined,
  SearchOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import { Helmet } from "react-helmet";
import { formatInTimeZone } from "date-fns-tz";
import HistoryTable from "../../Components/HistoryTable/HistoryTable";
import { HistoryFilter } from "../../Components/modals/HistoryFilter";
import { historyAPI } from "../../API/HistoryAPI";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import { HistorySelectedColumns } from "../../Components/modals/HisorySelectedColumns";
import { DEFUALT_COLUMNS } from "./HistoryUtils";
import BottomTab from "../../Components/BottomTab/BottomTab";
const { Text } = Typography;

export const History = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [messageApi, contextHolder] = message.useMessage();
  const [HistoryData, setHistoryData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(DEFUALT_COLUMNS);
  const [openselectColumns, setOpenSelectColumns] = useState(false);
  const [openHistoryFilter, setOpenHistoryFilter] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [defualtData, setDefualtData] = useState([]);
  const [serachVal, setSearchVal] = useState("");
  const [spinning, setSpinning] = useState(false);
  const [historyList, SetHistoryList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredValues, setFilteredvalues] = useState({
    cat: "",
    status: [],
    task: [],
    specType: "",
    // yieldValue: 90,
    yieldValueFrom: 0,
    yieldValueTo: 100,
    maintenanceCheck: "",
    maintenanceCheckPackage: "",
    maintenanceCheckInterval: "",
    maintenanceCheckPackageInterval: "",
  });
  const [filterStatus, setFilterStatus] = useState(false);

  const messageToast = useCallback(
    (type, message) => {
      messageApi.open({
        type: type,
        content: message,
        duration: 6,
      });
    },
    [messageApi],
  );

  const serachFun = useCallback(async () => {
    if (!selectedMonth) return;
    setSpinning(true);
    const selectedMonthData = historyList.find(
      (month) => month.value === selectedMonth,
    );
    const bodyData = {
      flight_model: localStorage.getItem("flight_model"),
      upload_history_id: selectedMonthData
        ? selectedMonthData.upload_history_id
        : "",
      upper_range: selectedMonthData ? selectedMonthData.upper_range : "",
      page: 1,
      page_size: pageSize,
      search: serachVal,
    };
    await historyAPI
      .getHistoryList(bodyData)
      .then((res) => {
        if (res.data.status === true) {
          setHistoryData(res.data.data);
          setDefualtData(res.data.data);
          setTotalRecords(res.data.total);
          setPage(res.data.page);
          setPageSize(res.data.page_size);
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      })
      .finally(() => {
        setSpinning(false);
      });
  }, [pageSize, selectedMonth, historyList, serachVal, messageToast]);

  const deferredQuery = useDeferredValue(serachVal);
  useEffect(() => {
    serachFun();
  }, [deferredQuery, serachFun]);

  const getHistoryMonths = useCallback(async () => {
    setSpinning(true);
    const queryParams = {
      params: {
        flight_model: localStorage.getItem("flight_model"),
      },
    };
    await historyAPI
      .getHistoryMonths(queryParams)
      .then((res) => {
        if (res.data.status === true) {
          const monthsArray = res.data.snapshots.map((ele) => {
            return {
              ...ele,
              value: ele.upper_range,
              label: `${formatInTimeZone(ele.upper_range, timeZone, "MMM dd yyyy hh:mm:ss a")}`,
            };
          });

          monthsArray.sort((a, b) => new Date(b.value) - new Date(a.value));
          SetHistoryList(monthsArray);

          const selectedMonthData = monthsArray.find(
            (month) => month.lower_range === null,
          );
          if (selectedMonthData) {
            setSelectedMonth(selectedMonthData.value);
          }
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      })
      .finally(() => {
        setSpinning(false);
      });
  }, [timeZone, messageToast]);

  const getHistoryData = useCallback(
    async (pageNo, pageCount) => {
      setSpinning(true);
      const selectedMonthData = historyList.find(
        (month) => month.value === selectedMonth,
      );
      const bodyData = {
        flight_model: localStorage.getItem("flight_model"),
        upload_history_id: selectedMonthData
          ? selectedMonthData.upload_history_id
          : "",
        upper_range: selectedMonthData ? selectedMonthData.upper_range : "",
        page: pageNo,
        page_size: pageCount,
        search: serachVal,
      };
      await historyAPI
        .getHistoryList(bodyData)
        .then((res) => {
          if (res.data.status === true) {
            setHistoryData(res.data.data);
            setDefualtData(res.data.data);
            setTotalRecords(res.data.total);
            setPage(res.data.page);
            setPageSize(res.data.page_size);
          } else {
            messageToast("error", res.data?.message);
          }
        })
        .catch((err) => {
          messageToast("error", "Internal Server Error");
        })
        .finally(() => {
          setSpinning(false);
        });
    },
    [selectedMonth, historyList, messageToast, serachVal],
  );

  useEffect(() => {
    setSpinning(true);
    getHistoryMonths();
  }, [getHistoryMonths]);

  useEffect(() => {
    if (selectedMonth) {
      getHistoryData(page, pageSize);
    }
  }, [selectedMonth, getHistoryData, page, pageSize]);

  const dateRangeLabel = useMemo(() => {
    const selectedMonthData = historyList.find(
      (month) => month.value === selectedMonth,
    );
    if (selectedMonthData) {
      const upperRange = selectedMonthData.upper_range;
      const lowerRange = selectedMonthData.lower_range;
      const formattedUpperRange = formatInTimeZone(
        upperRange,
        timeZone,
        "MMM dd yyyy hh:mm:ss a",
      );
      if (lowerRange) {
        const formattedLowerRange = formatInTimeZone(
          lowerRange,
          timeZone,
          "MMM dd yyyy hh:mm:ss a",
        );
        return `${formattedLowerRange} - ${formattedUpperRange}`;
      } else {
        return formattedUpperRange;
      }
    }
    return "";
  }, [selectedMonth, historyList, timeZone]);

  async function exportExcel() {
    setSpinning(true);
    try {
      const selectedMonthData = historyList.find(
        (month) => month.value === selectedMonth,
      );
      const bodyData = {
        flight_model: localStorage.getItem("flight_model"),
        upload_history_id: selectedMonthData
          ? selectedMonthData.upload_history_id
          : "",
        upper_range: selectedMonthData ? selectedMonthData.upper_range : "",
        page: page,
        page_size: pageSize,
        search: serachVal,
        export: true,
      };

      const response = await historyAPI.exportRankList(bodyData);

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Extract filename from content-disposition header if provided by backend
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "History_export.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=(['"]?)([^'"\n;]*)\1/,
        );
        if (match?.[2]) fileName = match[2].trim();
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      messageToast("error", "Export failed. Please try again.");
    } finally {
      setSpinning(false);
    }
  }

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | History</title>
      </Helmet>
      <HeaderTab currrentTab="history" />

      <Spin spinning={spinning}>
        <div className="box_wraper_div">
          <div className="table_head_wraper">
            <Text className="table_head">
              History of
              <label style={{ textTransform: "capitalize", marginLeft: "5px" }}>
                {selectedMonth && dateRangeLabel}
              </label>
            </Text>
            <div className="table_custom_buttons">
              <div
                style={{
                  borderRadius: "25px",
                  backgroundColor: "#EBEEF8",
                  color: "#737373",
                  display: "flex",
                  flex: "1 1 0px ",
                }}
              >
                <input
                  value={serachVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                  className="searc_input"
                />
                <SearchOutlined
                  className="search_btn"
                  style={{
                    color: !serachVal ? "#737373" : "#ff4d4f",
                    fontSize: "18px",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              </div>
              <Select
                style={{
                  fontSize: "13px",
                  width: 220,
                  flex: "1 1 0px ",
                }}
                placeholder="--slect month--"
                value={selectedMonth}
                onChange={(e) => {
                  setSelectedMonth(e);
                  setPage(1);
                }}
                options={historyList}
              />
              <Dropdown
                placement="bottomRight"
                menu={{
                  items: [
                    // {
                    //   key: "1",
                    //   label: (
                    //     <div
                    //       onClick={() => setOpenSelectColumns(true)}
                    //       style={{ fontSize: "18px", minWidth: "150px" }}
                    //     >
                    //       <GroupOutlined />{" "}
                    //       <Text style={{ marginLeft: "10px" }}>Columns</Text>
                    //     </div>
                    //   ),
                    // },
                    // {
                    //   key: "2",
                    //   label: (
                    //     <div
                    //       onClick={() => setOpenHistoryFilter(true)}
                    //       style={{ fontSize: "18px", minWidth: "150px" }}
                    //     >
                    //       <Badge dot={filterStatus}>
                    //         <FilterFilled />{" "}
                    //       </Badge>{" "}
                    //       <Text style={{ marginLeft: "10px" }}>Filter</Text>
                    //     </div>
                    //   ),
                    // },
                    {
                      key: "3",
                      label: (
                        <div
                          onClick={exportExcel}
                          style={{ fontSize: "18px", minWidth: "150px" }}
                        >
                          <ExportOutlined />{" "}
                          <Text style={{ marginLeft: "10px" }}>
                            Export to Excel
                          </Text>
                        </div>
                      ),
                    },
                  ],
                }}
                trigger={["click"]}
              >
                <Badge dot={filterStatus}>
                  <Button
                    disabled={defualtData.length > 0 ? false : true}
                    type="primary"
                    style={{ backgroundColor: "#EBEEF8", color: "#304CB2" }}
                    icon={<EllipsisOutlined />}
                  >
                    Actions
                  </Button>
                </Badge>
              </Dropdown>
            </div>
          </div>

          <HistoryTable
            listData={HistoryData}
            selectedColumns={selectedColumns}
            page={page}
            pageSize={pageSize}
            totalRecords={totalRecords}
            getHistoryDataFun={getHistoryData}
            selectedMonth={selectedMonth}
            filteredValues={filteredValues}
            serachVal={serachVal}
            setPage={setPage}
            setPageSize={setPageSize}
            setTotalRecords={setTotalRecords}
            setHistoryData={setHistoryData}
            pageType="History"
          />

          <HistorySelectedColumns
            open={openselectColumns}
            setOpen={setOpenSelectColumns}
            selectedColumns={selectedColumns}
            setSelectedColumns={setSelectedColumns}
            getRankingDataFun={getHistoryData}
            defualtColumns={DEFUALT_COLUMNS}
            selectedMonth={selectedMonth}
          />
          <HistoryFilter
            open={openHistoryFilter}
            setOpen={setOpenHistoryFilter}
            listData={HistoryData}
            setListData={setHistoryData}
            defualtData={defualtData}
            filteredValues={filteredValues}
            setFilteredvalues={setFilteredvalues}
            serachVal={serachVal}
            setFilterStatus={setFilterStatus}
            selectedMonth={selectedMonth}
            page="History"
            pageSize={pageSize}
            pageNo={page}
          />
        </div>
      </Spin>

      <BottomTab />
      {contextHolder}
    </div>
  );
};
